import { heroData } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-[72px] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-5 whitespace-nowrap">
              <i className="ri-sparkling-line text-sm"></i>
              <span>{heroData.tagline}</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-foreground-950 leading-tight mb-4">
              {heroData.title}
              <span className="block text-xl md:text-2xl lg:text-3xl text-foreground-600 font-body font-light mt-2">
                {heroData.subtitle}
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3 max-w-xl mx-auto lg:mx-0">
              {heroData.description1}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              {heroData.description2}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {heroData.stats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-xl md:text-2xl font-heading text-primary-500">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                className="w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                {heroData.primaryCta.label}
              </a>
              <a
                href={heroData.secondaryCta.href}
                className="w-full sm:w-auto px-8 py-3 rounded-full border-2 border-background-300 text-foreground-700 font-medium text-sm hover:border-primary-300 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                {heroData.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-primary-200/30 via-accent-100/20 to-secondary-100/30 rounded-2xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Magical%20fantasy%20comic%20books%20floating%20in%20a%20warm%20golden%20library%20with%20sparkling%20magic%20dust%20and%20glowing%20runes%2C%20ancient%20books%20open%20with%20light%20emanating%20from%20pages%2C%20mystical%20atmosphere%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20fantasy%20illustration%20style%2C%20soft%20ethereal%20glow%2C%20magical%20floating%20particles%2C%20enchanting%20and%20inviting%20mood&width=1200&height=900&seq=hero-main-visual&orientation=portrait"
                alt="非麻瓜漫画 - 魔法奇幻漫画世界"
                className="relative w-full h-auto rounded-2xl object-cover"
                width="600"
                height="450"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}